import React from 'react';
import { Users, FileText, Globe, Smartphone } from 'lucide-react';

const MetricCards = ({ data }) => {
  const formSubmissions = data.filter(v => v.form_submitted === 'Yes').length;
     const uniqueIPsSet = new Set();
    const mobileDevices = data.filter(v => 
      v.user_agent && /(android|iphone|ipod|ipad|mobile)/i.test(v.user_agent)
    ).length;
    
    data.forEach(v => {
      if (v.ip && v.ip !== 'UNKNOWN') {
        uniqueIPsSet.add(v.ip);
      }
    });
  const metrics = [
    {
      title: 'Total Visitors',
      value: data.length,
      icon: Users,
      color: 'bg-blue-500',
      change: '+12%'
    },
    {
      title: 'Form Submissions',
      value: formSubmissions,
      icon: FileText,
      color: 'bg-purple-500',
      change: '+8%'
    },
    {
      title: 'Unique IPs',
      value: uniqueIPsSet.size,
      icon: Globe,
      color: 'bg-green-500',
      change: '+15%'
    },
    {
      title: 'Mobile Devices',
      value: mobileDevices,
      icon: Smartphone,
      color: 'bg-orange-500',
      change: '+5%'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => {
        const Icon = metric.icon;
        return (
          <div key={index} className="metric-card bg-white p-[24px] flex items-center justify-between">
              
              {/* <span className="text-sm font-medium text-green-600 dark:text-green-400">
                {metric.change}
              </span> */}
            <div className="text-left mt-2">
              <h3 className="text-md font-medium text-black dark:text-gray-400">
                {metric.title}
              </h3>
              <p className="text-3xl font-bold text-black  mt-1">
                {metric.value}
              </p>
            </div>
            <div className={`p-3 rounded-xl ${metric.color}`}>
                <Icon className="h-6 w-6 text-white" />
              </div>
          </div>
        );
      })}
    </div>
  );
};

export default MetricCards;
